import { WorkSheet, utils, write, writeFile } from "xlsx";
import { FlightService } from "../../../../../services/flights/flight.service";
import { DiversionDecisionStatus } from "../../../../../services/flights/typings/IFlightResponse";
import MedicalEmergencyService from "../../../../../services/medical-emergency/medical-emergency.service";
import { MedicalEmergencyStatus } from "../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import VideocallService from "../../../../../services/videocall/videocall.service";
import { Hash } from "../../../../../typings/Hash";
import Utility from "../../../../../util/api/Utility";

interface graphData {
  count: number;
  date: string;
}
interface vcGraphData {
  label: string;
  data: graphData[]
}
export default class HomeScreenService {
  static async getNumberOfMedicalEmergencies(
    startDate?: string,
    endDate?: string
  ) {
    // date conversion
    const startDateParsedMillis = startDate
      ? new Date(Date.parse(startDate)).getTime()
      : 0;
    const endDateParsedMillis = endDate
      ? new Date(Date.parse(endDate)).getTime()
      : new Date().getTime();

    const length = (
      await MedicalEmergencyService.listMedicalEmergencies()
    ).filter((medicalEmergency) => {
      const timestampDate = new Date(
        Date.parse(medicalEmergency.timestamp)
      ).getTime();
      return (
        startDateParsedMillis <= timestampDate &&
        timestampDate <= endDateParsedMillis
      );
    }).length;
    return length;
  }

  static async getNumberOfFlights() {
    return (await FlightService.listFlights()).length;
  }

  static async getDiversionStatusRatio(
    startDate: string
  ): Promise<DiversionStatusRatioType> {
    const flights = await FlightService.listFlights();
    function convertDateToISO(dateString: string) {
      // Create a new Date object from the given date string
      const date = new Date(dateString);
      // Get the year, month, day, hours, minutes, seconds, and milliseconds from the date object
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      // Construct the ISO string
      const isoString = `${year}-${month}-${day}`;
      return isoString;
    }
    const filteredFlights = flights.filter((flight) => {
      return convertDateToISO(flight.createdAt) >= convertDateToISO(startDate);
    });
    const ratio = filteredFlights.reduce(
      (total, current) => {
        if (
          current.diversionDecisionStatus ===
          DiversionDecisionStatus.DIVERSION_REQUIRED
        ) {
          // alert(JSON.stringify(current))
          total.diversionRecommended = total.diversionRecommended + 1;
        } else {
          total.notRecommended = total.notRecommended + 1;
        }
        return total;
      },
      { diversionRecommended: 0, notRecommended: 0 } as DiversionStatusRatioType
    );
    console.log("finalratio", ratio);
    return ratio;
  }

  static async getMedicalEmergencyStatusCounts() {
    const medicalEmergencies =
      await MedicalEmergencyService.listMedicalEmergencies();
    const counts = medicalEmergencies.reduce((total, current) => {
      const count = total[current.status.toString()];
      if (count != undefined) {
        total[current.status.toString()] = count + 1;
      } else {
        total[current.status.toString()] = 1;
      }
      return total;
    }, {} as Hash<number>);
    return counts;
  }

  static async getVideocallTimelineData(
    fdate: string,
    tdate: string,
    activeBtnCount: number
  ) {
    if (fdate != undefined && tdate != undefined) {
      let videocalls = await VideocallService.getVideoCallRecord(fdate, tdate);
      console.log("videocalls", videocalls);
      return videocalls;
      // if (activeBtnCount == 2) {
      //   const getMonth = (dateString: string) => {
      //     const date = new Date(dateString);
      //     const monthIndex = date.getMonth();
      //     return monthIndex;
      //   };
      //   let emsData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      //   let crewData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      //   let pilotData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      //   videocalls.map((videoCall) => {
      //     let monthIndex = getMonth(videoCall.date);
      //     if (videoCall.userType == "ems") {
      //       emsData[monthIndex] += videoCall.count;
      //     } else if (videoCall.userType == "crew") {
      //       crewData[monthIndex] += videoCall.count;
      //     } else if (videoCall.userType == "captain") {
      //       pilotData[monthIndex] += videoCall.count;
      //     } else {
      //     }
      //   });

      //   let videoCallData = {
      //     ems: emsData,
      //     pilot: pilotData,
      //     crew: crewData,
      //   };
      //   return videoCallData;
      // } else if (activeBtnCount == 0) {
      //   const getDayOfWeek = (dateString: string) => {
      //     const date = new Date(dateString);
      //     const dayIndex = date.getDay();
      //     return dayIndex;
      //   };
      //   let emsData = [0, 0, 0, 0, 0, 0, 0];
      //   let crewData = [0, 0, 0, 0, 0, 0, 0];
      //   let pilotData = [0, 0, 0, 0, 0, 0, 0];

      //   videocalls.map((videoCall) => {
      //     let monthIndex = getDayOfWeek(videoCall.date);
      //     if (videoCall.userType == "ems") {
      //       emsData[monthIndex] += videoCall.count;
      //     } else if (videoCall.userType == "crew") {
      //       crewData[monthIndex] += videoCall.count;
      //     } else if (videoCall.userType == "captain") {
      //       pilotData[monthIndex] += videoCall.count;
      //     } else {
      //     }
      //   });

      //   let videoCallData = {
      //     ems: emsData,
      //     pilot: pilotData,
      //     crew: crewData,
      //   };
      //   return videoCallData;
      // } else if (activeBtnCount == 1) {
      //   // Initialize empty arrays
      //   const ems: [] = [];
      //   const captain: [] = [];
      //   const crew: [] = [];

      //   // Function to add counts to the respective arrays
      //   const addToArray = (
      //     array: { count: number | null; date: string | null }[],
      //     userType: string,
      //     date: string,
      //     count: number
      //   ) => {
      //     let found = false;
      //     for (let item of array) {
      //       if (item.date === date && item.count != null) {
      //         item.count += count;
      //         found = true;
      //         break;
      //       }
      //     }
      //     if (!found) {
      //       array.push({ date: date, count: count });
      //     }
      //   };

      //   // Iterate over the data and update arrays
      //   videocalls.forEach((entry) => {
      //     const { userType, count, date } = entry;
      //     if (userType === "ems") {
      //       addToArray(ems, userType, date, count);
      //     } else if (userType === "captain") {
      //       addToArray(captain, userType, date, count);
      //     } else if (userType === "crew") {
      //       addToArray(crew, userType, date, count);
      //     }
      //   });

      //   // Function to get sorted unique dates
      //   const getSortedUniqueDates = (arrays: any) => {
      //     const dates = new Set();
      //     arrays.forEach((array: any) => {
      //       array.forEach((item: any) => dates.add(item.date));
      //     });
      //     return Array.from(dates).sort();
      //   };
      //   const labels = getSortedUniqueDates([ems, crew, captain]);
      //   const getCountsForDate = (array: any, date: string) => {
      //     const item = array.find((entry: any) => entry.date === date);
      //     return item ? item.count : 0;
      //   };
      //   const emsFinalData = labels.map((date: any) =>
      //     getCountsForDate(ems, date)
      //   );
      //   const crewFinalData = labels.map((date: any) =>
      //     getCountsForDate(crew, date)
      //   );
      //   const captainFinalData = labels.map((date: any) =>
      //     getCountsForDate(captain, date)
      //   );
      //   let videoCallData = {
      //     ems: emsFinalData,
      //     pilot: captainFinalData,
      //     crew: crewFinalData,
      //     labels: labels,
      //   };
      //   return videoCallData;
      // } else {
      // }
    }
  }

  static async getVideocallTimelineData2() {
    let data: VideocallTimelineDataPointType[] = [];
    const timeCallCountMap: Hash<number> = {};

    const videocalls = await VideocallService.listVideoCalls();
    videocalls.forEach((videocall) => {
      const time = Utility.formatDateShort(videocall.timestamp);
      const count = timeCallCountMap[time];
      if (count != undefined) {
        timeCallCountMap[time] = count + 1;
      } else {
        timeCallCountMap[time] = 1;
      }
    });

    data = Object.keys(timeCallCountMap).map((time) => {
      return {
        x: time,
        y: timeCallCountMap[time],
      };
    });
    console.log(data);

    return data;
  }

  static async getTodaysVideocallCount() {
    const videocalls = await VideocallService.listVideoCalls();

    const now = new Date();
    const nowString = `${now.getUTCDate()}/${now.getUTCMonth()}/${now.getUTCFullYear()}`;

    return videocalls.filter((videocall) => {
      const videocallCreationDate = new Date(Date.parse(videocall.timestamp));
      const videocallCreationDateString = `${videocallCreationDate.getUTCDate()}/${videocallCreationDate.getUTCMonth()}/${videocallCreationDate.getUTCFullYear()}`;
      if (nowString === videocallCreationDateString) {
        return true;
      }
      return false;
    }).length;
  }

  static async saveAsExcel(
    dataSets: { data: any; sheetName: string }[],
    filename: string
  ) {
    // var data = [
    //   { name: "John", city: "Seattle" },
    //   { name: "Mike", city: "Los Angeles" },
    //   { name: "Zach", city: "New York" }
    // ];
    // let header = ["Name", "City"];
    const worksheets: { workSheet: WorkSheet; sheetName: string }[] = [];

    dataSets.forEach((dataSet) => {
      var workSheet = utils.json_to_sheet(dataSet.data);
      worksheets.push({ workSheet, sheetName: dataSet.sheetName });
    });

    var wb = utils.book_new();

    worksheets.forEach((_worksheet) =>
      utils.book_append_sheet(wb, _worksheet.workSheet, _worksheet.sheetName)
    );

    return writeFile(wb, filename, {
      bookType: "xlsx",
    });
    // /return new Blob([excelBu], { type: "" });
  }

  static async exportInExcel(startDate: string, endDate: string) {
    // date conversion
    const startDateParsedMillis = new Date(Date.parse(startDate)).getTime();
    const endDateParsedMillis = new Date(Date.parse(endDate)).getTime();

    // get data from server
    const medicalEmergencies =
      await MedicalEmergencyService.listMedicalEmergencies();
    const flights = await FlightService.listFlights();
    const videocalls = await VideocallService.listVideoCalls();

    // filter medical emergencies
    const filteredMedicalEmergencies = medicalEmergencies.filter(
      (medicalEmergecy) => {
        const timestampDate = new Date(
          Date.parse(medicalEmergecy.timestamp)
        ).getTime();
        return (
          startDateParsedMillis <= timestampDate &&
          timestampDate <= endDateParsedMillis
        );
      }
    );
    // filter flights (change once the scheduledArv and dep changes are pushed to the prod)
    const filteredFlights = flights;
    // filter videocalls
    const filteredVideocalls = videocalls.filter((videocall) => {
      const timestampDate = new Date(Date.parse(videocall.timestamp)).getTime();
      return (
        startDateParsedMillis <= timestampDate &&
        timestampDate <= endDateParsedMillis
      );
    });

    await this.saveAsExcel(
      [
        {
          data: filteredMedicalEmergencies,
          sheetName: "Medical Emergencies Data",
        },
        {
          data: filteredVideocalls,
          sheetName: "Video calls history",
        },
        { data: filteredFlights, sheetName: "Flights Data" },
      ],
      `Safeair-data-${new Date().toISOString()}.xlsx`
    );
  }
}

type DiversionStatusRatioType = {
  diversionRecommended: number;
  notRecommended: number;
};

export type VideocallTimelineDataPointType = {
  x: string;
  y: number;
};
